import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {PCContainerBox} from "../boxes/pc-container/pc-container.box";
import {getButtonsSeparator} from "../../header-welcome-buttons-helpers";
import {HeaderCashierButtonComponent} from "../../../buttons/cashier-button/header-cashier-button.component";
import React from "react";

export const HeaderWelcomeButtonsForAuthorizedUserPcViewComponent = observer(
    class HeaderWelcomeButtonsForAuthorizedUserPcViewComponent extends OrbitComponent {
        render() {
            return (
                <PCContainerBox>
                    {getButtonsSeparator(this.services)}
                    <HeaderCashierButtonComponent/>
                </PCContainerBox>
            );
        }
    }
);